module.exports = __webpack_public_path__ + "img/desc.64856df8.png";